export default __webpack_public_path__ + "static/media/icon_acknowledge.0342df09.svg";